import { Anchor } from "@mantine/core";
import React from "react";

const ClickableTableIdButton: React.FC<{
  id: any;
  _id: string;
  setItem: (_id: string) => void;
  prefix?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}> = ({ id, _id, setItem, prefix, icon, disabled }) => {
  return (
    <>
      {disabled !== true ? (
        <Anchor fw="bold" onClick={() => setItem(_id)}>
          <u>
            {icon}
            {prefix}
            {id}
          </u>
        </Anchor>
      ) : (
        <b>
          {icon}
          {prefix}
          {id}
        </b>
      )}
    </>
  );
};

export default ClickableTableIdButton;
